import React, { useState, useEffect } from "react";
import axios from "axios";
import fieldsConfig from "./registerUserFields.json";
import "./RegisterUsers.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const RegisterUsers = () => {
  const [form, setForm] = useState({});
  const [options, setOptions] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const baseApi = "https://lttsbackend.axiomos.in";

  // 🔵 Initialize form default values
  useEffect(() => {
    const initial = {};
    fieldsConfig.forEach((f) => {
      if (f.array) initial[f.field] = [];
      else initial[f.field] = "";
    });
    setForm(initial);
  }, []);

  // 🔵 Fetch dropdown/checkbox API data
  useEffect(() => {
    fieldsConfig.forEach(async (f) => {
      if (f.api) {
        try {
          const res = await axios.get(f.api);
          setOptions((prev) => ({ ...prev, [f.field]: res.data || [] }));
        } catch (err) {
          console.error(`API fetch failed for ${f.field}`, err);
        }
      }
    });
  }, []);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleCheckboxArray = (key, id) => {
    let arr = [...form[key]];

    if (arr.includes(id)) arr = arr.filter((x) => x !== id);
    else arr.push(id);

    setForm({ ...form, [key]: arr });
  };

  // 🔵 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    try {
      await axios.post(`${baseApi}/user/create`, form);
      setMsg("✅ User created successfully!");
    } catch (err) {
      setMsg(err.response?.data?.message || "❌ Failed to create user");
    }

    setLoading(false);
  };

  return (
    <div className="regUser-wrapper">
      <div className="regUser-card">
        <h2 className="regUser-title">Create Your JKumar SafetySure Account</h2>
        <p className="regUser-subtitle">
          Fill in the details below to request access to the safety admin
          portal.
        </p>

        <form className="regUser-form" onSubmit={handleSubmit}>
          {fieldsConfig.map((f) => (
            <div key={f.field} className="regUser-form-group">
              <label className="regUser-label">
                {f.label} {f.required && <span className="req">*</span>}
              </label>

              {/* TEXT & EMAIL INPUT */}
              {["text", "email"].includes(f.type) && (
                <input
                  className="regUser-input"
                  type={f.type}
                  placeholder={`Enter ${f.label}`}
                  value={form[f.field]}
                  onChange={(e) => handleChange(f.field, e.target.value)}
                  required={f.required}
                />
              )}

              {/* TEXTAREA */}
              {f.type === "textarea" && (
                <textarea
                  className="regUser-textarea"
                  placeholder={`Enter ${f.label}`}
                  value={form[f.field]}
                  onChange={(e) => handleChange(f.field, e.target.value)}
                  required={f.required}
                />
              )}

              {/* PASSWORD */}
              {f.type === "password" && (
                <div className="regUser-pass-wrapper">
                  <input
                    className="regUser-input"
                    type={showPassword ? "text" : "password"}
                    placeholder={`Enter ${f.label}`}
                    value={form[f.field]}
                    onChange={(e) => handleChange(f.field, e.target.value)}
                    required={f.required}
                  />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    className="regUser-pass-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              )}

              {/* DROPDOWN */}
              {f.type === "dropdown" && (
                <select
                  className="regUser-select"
                  value={form[f.field]}
                  onChange={(e) => handleChange(f.field, e.target.value)}
                  required={f.required}
                >
                  <option value="">Select {f.label}</option>
                  {options[f.field]?.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item[f.apiTitle]}
                    </option>
                  ))}
                </select>
              )}

              {/* CHECKBOX MULTIPLE SELECT */}
              {f.type === "checkbox" && f.array && (
                <div className="regUser-checkbox-list">
                  {options[f.field]?.map((item) => (
                    <label key={item._id} className="regUser-checkbox-item">
                      <input
                        type="checkbox"
                        checked={form[f.field]?.includes(item._id)}
                        onChange={() => handleCheckboxArray(f.field, item._id)}
                      />
                      <span>{item[f.apiTitle]}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
          ))}

          <button
            type="submit"
            disabled={loading}
            className="regUser-submit-btn"
          >
            {loading ? "Creating Account..." : "Create Account"}
          </button>

          {msg && <p className="regUser-msg">{msg}</p>}
        </form>
      </div>
    </div>
  );
};

export default RegisterUsers;
